/**
 * Created by Kaku.Guo on 2018/12/12.
 */
import axios from 'axios';
import Url from '../constants/Url';

class ShoppingCartApi {
    getOffers() {
        return axios.get(Url().SHOPPING_CART.LIST)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
    addOffer(params) {
        return axios.post(Url().SHOPPING_CART.ADD, params)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
    removeOffer(params) {
        return axios.post(`${Url().SHOPPING_CART.DELETE}?offerId=${params.offerId}`)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
    clearOffers() {
        return axios.post(Url().SHOPPING_CART.CLEAR)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
    purchase(params) {
        return axios.get(Url().PURCHASE.GET, { params })
            .then(response => response.data)
            .catch((ex) => { throw ex; });
    }
    trackPurchaseType(params) {
        return axios.post(Url().PURCHASE.TRACK, params)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
}
export default new ShoppingCartApi();